import { useState, useEffect } from "react";
import Image from "next/image";
import { useRouter } from "next/router";
import ImgixLoader from "@utils/images/ImgixLoader";
import ProductZoomModal from "./ProductZoomModal";

function ProductGalery({ pictures }) {
  const router = useRouter();

  const [modalPicture, setModalPicture] = useState({ open: false, indexStart: 0 });

  function openZoomModal(indexStart) {
    router.push("#product-zoom-modal");
    setModalPicture({ open: true, indexStart });
  }

  function closeModal() {
    router.back();
  }

  useEffect(() => {
    if (modalPicture.open) {
      router.beforePopState(() => {
        setModalPicture({ open: false, indexStart: 0 });
      });
    } else {
      router.beforePopState();
    }
  }, [router, modalPicture.open]);

  return (
    <div className="product-galery">
      <div className="product-galery-content">
        {pictures.map((picture, index) => (
          <div
            key={picture.id}
            className="product-galery-item"
          >
            <Image
              loader={ImgixLoader}
              src={picture.large_url}
              onClick={() => openZoomModal(index)}
              alt=""
              fill
              sizes="(max-width: 576px) 512px,
              (max-width: 992px) 640px,
              (max-width: 1200px) 384px,
              (max-width: 1400px) 448px,
              1024px"
            />
          </div>
        ))}
      </div>

      <ProductZoomModal
        show={modalPicture.open}
        close={closeModal}
        pictures={pictures}
        indexStart={modalPicture.indexStart}
      />
    </div>
  );
}

export default ProductGalery;
